import { render, staticRenderFns } from "./cursorMusic.vue?vue&type=template&id=246337b6&scoped=true"
import script from "./cursorMusic.vue?vue&type=script&lang=js"
export * from "./cursorMusic.vue?vue&type=script&lang=js"
import style0 from "./cursorMusic.vue?vue&type=style&index=0&id=246337b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246337b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246337b6')) {
      api.createRecord('246337b6', component.options)
    } else {
      api.reload('246337b6', component.options)
    }
    module.hot.accept("./cursorMusic.vue?vue&type=template&id=246337b6&scoped=true", function () {
      api.rerender('246337b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/cursorMusic.vue"
export default component.exports